import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import type {
  SeasonApiRecord,
  SeasonsListResponse,
  UnscheduleSeasonResponse,
} from "../../types/gamePass";
import { getPrivateInstance } from "../_privateInstance";
import { unwrapGamePassEntity } from "./responseMappers";

const buildUnscheduleSeasonUrl = (seasonId: string): string =>
  API_ROUTES.UNSCHEDULE_SEASON.replace("{season_id}", seasonId);

const postUnscheduleSeason = async (seasonId: string): Promise<SeasonApiRecord> => {
  const response = await getPrivateInstance().post<UnscheduleSeasonResponse>(
    buildUnscheduleSeasonUrl(seasonId),
    {},
  );
  return unwrapGamePassEntity(response.data, "season");
};

export const useUnscheduleSeason = (): UseMutationResult<
  SeasonApiRecord,
  Error,
  string
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["game-pass", "seasons", "unschedule"],
    mutationFn: postUnscheduleSeason,
    onSuccess: (season) => {
      queryClient.setQueriesData<SeasonsListResponse>(
        { queryKey: ["game-pass", "seasons", "list"] },
        (current) => {
          if (!current) return current;
          return {
            ...current,
            seasons: current.seasons.map((record) =>
              (record.id ?? record.season_id) === (season.id ?? season.season_id)
                ? { ...record, ...season }
                : record,
            ),
          };
        },
      );
      queryClient.invalidateQueries({
        queryKey: ["game-pass", "seasons", "list"],
      });
    },
  });
};
